import React, { useState, useEffect } from 'react'

const ClientReports = ({ userDetails }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchReports = async () => {
      try {
        // Make an API request with the user ID from userDetails
        const response = await fetch(`http://localhost:3002/api/get-daily-reports?userId=${userDetails.id}`);
        if (!response.ok) {
          throw new Error('Failed to fetch reports');
        }
        const data = await response.json();
        setReports(data); // Store the reports data in state
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false); // Set loading to false after the request completes
      }
    };

    fetchReports();
  }, [userDetails.id]); // Trigger the effect whenever the userDetails.id changes


  const formatDate = (dateString) => {
    const date = new Date(dateString); // Create Date object
    return date.toLocaleDateString(); // Default format is 'MM/DD/YYYY' in the browser's locale
  };

  return (
    <>
      <section className='py-5'>
        <div className='container'>

          <p className='sec-subheading'><hr /><span>My Daily Reports</span><hr /></p>

          <div className='table-responsive text-center mt-4'>
            <table className='w-100'>

              <tr className='bg-light para-text'>
                <th className='py-3 px-2'>S. No</th>
                <th className='py-3 px-2'>Visit Date</th>
                <th className='py-3 px-2'>Site Name</th>
                <th className='py-3 px-2'>Reason</th>
                <th className='py-3 px-2'>Places Visited</th>
              </tr>

              {loading && <tr><td colSpan='5' className='py-3 px-2'>Loading reports...</td></tr>}

              {reports.length === 0 ? (
                <tr>
                  <td colSpan='5' className='py-3 px-2'>No reports found.</td>
                </tr>
              ) : (
                reports.map((report, index) => (
                  <tr className='text-muted para-text' key={report.id}>
                    <td className='py-3 px-2'>{index + 1}</td>
                    <td className='py-3 px-2'>{formatDate(report.visit_date)}</td>
                    <td className='py-3 px-2'>{report.site}</td>
                    <td className='py-3 px-2'>{report.reason}</td>
                    <td className='py-3 px-2'>{report.places}</td>
                  </tr>
                ))
              )}


            </table>
          </div>
          {/* table ends */}

        </div>
      </section>
    </>
  )
}

export default ClientReports
